import { render, staticRenderFns } from "./report-manager.vue?vue&type=template&id=224ce61a"
import script from "./report-manager.vue?vue&type=script&lang=js"
export * from "./report-manager.vue?vue&type=script&lang=js"
import style0 from "./report-manager.vue?vue&type=style&index=0&id=224ce61a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports